import type { MediaProvider } from '../types'

export interface DetectedMedia {
  provider: MediaProvider
  videoId?: string
  thumbnailUrl?: string
}

function youtubeResult(videoId: string): DetectedMedia {
  if (!videoId) return { provider: 'youtube' }
  return {
    provider: 'youtube',
    videoId,
    thumbnailUrl: `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`,
  }
}

// Detect the streaming provider behind a pasted link so the feed can show the
// right icon + (for YouTube) an auto thumbnail. Pure URL parsing — no network.
export function detectMedia(rawUrl: string): DetectedMedia {
  let url: URL
  try {
    url = new URL(rawUrl.trim())
  } catch {
    return { provider: 'other' }
  }
  const host = url.hostname.replace(/^www\./, '').toLowerCase()

  if (host === 'youtu.be') {
    return youtubeResult(url.pathname.slice(1).split('/')[0] ?? '')
  }
  if (host === 'youtube.com' || host === 'm.youtube.com' || host === 'music.youtube.com') {
    let id = url.searchParams.get('v') ?? ''
    if (!id) {
      const m = url.pathname.match(/^\/(?:shorts|embed|live)\/([^/?]+)/)
      if (m) id = m[1]
    }
    return youtubeResult(id)
  }
  if (host === 'soundcloud.com' || host.endsWith('.soundcloud.com')) {
    return { provider: 'soundcloud' }
  }
  if (host === 'open.spotify.com' || host === 'spotify.com') {
    return { provider: 'spotify' }
  }
  return { provider: 'other' }
}

// Human-friendly host label for a media link (e.g. "youtube.com").
export function mediaHostLabel(rawUrl: string): string {
  try {
    return new URL(rawUrl.trim()).hostname.replace(/^www\./, '')
  } catch {
    return rawUrl
  }
}
